import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AutenticacionService } from '../services/seguridad/autenticacion/autenticacion.service';
import { StorageService } from '../services/storage/storage.service';
import { OktaAuthService } from '../services/OktaAuth/okta-auth.service';

// import { AuthenticationService } from '@app/_services';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(
        private authenticationService: AutenticacionService, //AuthenticationService
        private oktaService: OktaAuthService,
        private storageService: StorageService,
        ) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(catchError(err => {
            if ([401, 403].includes(err.status) && this.oktaService.isAuthenticated()) {
                // auto logout if 401 or 403 response returned from api
                this.oktaService.logout();
            }

            if ([401, 403].includes(err.status) && this.storageService.isAuthenticated()) {
                // auto logout if 401 or 403 response returned from api
                // this.authenticationService.logout();
                
                this.storageService.logout();
            }

            const error = (err && err.error) || err.statusText;
            console.error(err);
            return throwError(error);
        }))
    }
}